
const state = {
  version: '',
  reload: false
}

const mutations = {
  version (state, newVersion) {
    state.reload = reloadIsRequired(state.version, newVersion)
    state.version = newVersion
  }
}

function reloadIsRequired (oldVersion, newVersion) {
  // Asumption: the versions are three numbers separated with dots
  if (!oldVersion || !newVersion) return false
  const ov = oldVersion.split('.')
  const nv = newVersion.split('.')
  return ov[0] !== nv[0] || ov[1] !== nv[1]
}

export default { namespaced: true, state, mutations }
